<template>
  <component :is="template" :spec="field.spec" :errors="field.errors" :saving="saving">
    <template #editable>
      <date-select v-model="proxy" type="single" bg="dark" class="w-100"/>
    </template>
    <template #readonly>
      <div class="flex items-center relative">
        <font-awesome-icon :icon="['far', 'calendar-alt']" class="text-tertiary absolute ml2"/>
        <span class="date-input">{{ showDate(field.value) }}</span>
      </div>
    </template>
  </component>
</template>

<script>
import DateSelect from '@/components/ui/DateSelect.vue'
const moment = require('moment')

export default {
  props: ['field', 'template', 'saving'],
  components: {
    DateSelect
  },
  watch: {
    field (f) {
      if (f.spec.causer) return
      this.model = f.value
    }
  },
  computed: {
    proxy: {
      get () {
        return this.model
      },
      set (value) {
        this.model = value
        if (!moment(this.model).isSame(this.field.value)) {
          this.$emit('input', { value: this.model, debounced: true })
        }
      }
    }
  },
  data () {
    return {
      model: this.field.value
    }
  },
  methods: {
    showDate (value) {
      return value ? moment(value).format('DD.MM.YYYY') : null
    }
  }
}
</script>
